module.exports = __webpack_public_path__ + "img/coffee-girl.28c5153.svg";